// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Tooltip from "@insite/mobius/Tooltip/Tooltip";
import * as React from "react";

type WarehouseHoursLinkProps = LinkPresentationProps & {
    warehouse: WarehouseModel;
};

const WarehouseHoursLink: React.FC<WarehouseHoursLinkProps> = ({ warehouse, ...otherProps }) => {
    if (!warehouse.hours) {
        return null;
    }

    return (
        <Link {...otherProps}>
            {translate("Hours")} <Tooltip text={warehouse?.hours} iconProps={{size: 12}} />
        </Link>
    );
};

export default WarehouseHoursLink;
